<template>
  <b-modal id="screenshotModal" ref="modal" centered hide-footer hide-header size="lg" @hidden="close">
    <section class="d-flex justify-content-center align-items-center">
      <a
        v-if="selectedScreenShotIndex > 0"
        class="start-button d-flex justify-self-start bg-light border p-3 rounded-circle shadow position-absolute"
        @click="showPrevious"
      >
        <img height="32" src="@/assets/icons/caret-right.svg">
      </a>
      <img
        v-show="!isLoadingScreenShot"
        :src="selectedScreenShotUrl"
        class="w-100"
        @load="screenshotLoaded"
      >
      <div v-show="isLoadingScreenShot" class="py-5">
        <SubscriptionLoading class="py-5 my-5" :is-loading="true" />
      </div>
      <a
        v-if="selectedScreenShotIndex !== configurations.screenShots.length - 1"
        class="end-button d-flex justify-self-end bg-light border p-3 rounded-circle shadow position-absolute"
        @click="showNext"
      >
        <img height="32" src="@/assets/icons/caret-left.svg">
      </a>
    </section>
  </b-modal>
</template>

<script>
import SubscriptionLoading from '@/components/SubscriptionLoading'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ProductScreenshotModal',
  components: {
    SubscriptionLoading
  },
  props: {
    configurations: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      selectedScreenShotIndex: 0,
      isLoadingScreenShot: false
    }
  },
  computed: {
    ...mapGetters({
      fileUrl: 'cdn/fileUrl'
    }),
    selectedScreenShotUrl () {
      return this.fileUrl(this.configurations.screenShots[this.selectedScreenShotIndex])
    }
  },
  mounted () {
    this.selectedScreenShotIndex = this.configurations.currentIndex
    this.$refs.modal.show()
  },
  methods: {
    ...mapActions({
      hide: 'modalManager/hide'
    }),
    showPrevious () {
      this.selectedScreenShotIndex--
      this.isLoadingScreenShot = true
    },
    showNext () {
      this.selectedScreenShotIndex++
      this.isLoadingScreenShot = true
    },
    screenshotLoaded () {
      this.isLoadingScreenShot = false
    },
    close () {
      this.hide()
    }
  }
}
</script>
